module.exports = __webpack_public_path__ + "img/xitong.9bf1e844.png";